export const PRODUCTPRICETYPE_CREATE_RESET = 'PRODUCTPRICETYPE_CREATE_RESET'
export const PRODUCTPRICETYPE_CREATE_SET_CREATED = 'PRODUCTPRICETYPE_CREATE_SET_CREATED'
export const PRODUCTPRICETYPE_CREATE_SET_ERROR = 'PRODUCTPRICETYPE_CREATE_SET_ERROR'
export const PRODUCTPRICETYPE_CREATE_SET_VIOLATIONS = 'PRODUCTPRICETYPE_CREATE_SET_VIOLATIONS'
export const PRODUCTPRICETYPE_CREATE_TOGGLE_LOADING = 'PRODUCTPRICETYPE_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/product_price_type/create/mutation_types.js